import React from "react";
import { useHistory } from "react-router-dom";
import { Select, Row, Col, Typography } from "antd";
import { EditFilled, CloseCircleOutlined } from "@ant-design/icons";

import InputLabel from "../FloatingSelectLabel/FloatingSelectLabel";

const { Option } = Select;
const { Text } = Typography;

const transformOptionValue = (array) => {
  if (array?.length > 0) {
    let elem = array?.pop();
    array?.push(Number.isInteger(elem) ? elem : +elem?.split("-")[0]);
    return array;
  }
  return array;
};

export default function DistrictSubProperty({
  data,
  subPropertyOfDistrict, //from zonesOfDistrict
  updateFormState,
  initialDistrictValue,
  getSubPropertyOfDistrict, //from getZonesOfDistrict
  cancelSelectedSubProperty, //cancelSelectedZone,
  isCircle,
  isEditMode,
}) {
  const generateSubPropertyOfDistrictLookup = (value) => {
    //generates key->value pair for zones(for tagRender function)
    if ([undefined, null].includes(value)) return value;
    return Object?.assign({}, ...value?.map((x) => ({ [x?.id]: x?.name })));
  };

  const isCancelledSubPropertyInInitialData = (
    initialData,
    cancelledSubProperty
  ) =>
    isCircle
      ? initialData?.circles?.find((x) => x?.id === cancelledSubProperty) ??
        false
      : initialData?.zones?.find((x) => x?.id === cancelledSubProperty) ??
        false;

  const history = useHistory();
  const [disableSubProperty, setDisableSubProperty] = React.useState(false);
  const [selectedSubProperty, setSelectedSubProperty] = React.useState(null);
  const [selectedDistrict, setSelectedDistrict] = React.useState(null);
  const [statusSelectActive, setStatusSelectActive] = React.useState(false);
  const [statusSelectActive2, setStatusSelectActive2] = React.useState(false);
  const subPropertyOfDistrictLookup = generateSubPropertyOfDistrictLookup(
    subPropertyOfDistrict
  ); //done

  const handleSelectChange = (x) => {

    if (!isEditMode) {

      x = transformOptionValue(x);
      setSelectedSubProperty(x);
    } else {
      x = transformOptionValue(x);
      setSelectedSubProperty((prev) => {
        if (
          [undefined, null].includes(prev?.length) ||
          x?.length > prev?.length
        ) {
          return x;
        } else return prev;
      });
    }
  };
  const tagRender = (props) => {
    const { value } = props;

    return (
      <div
        style={{
          backgroundColor: "#284F68",
          marginLeft: "2px",
          marginRight: "2px",
          borderRadius: "10px",
          padding: "2px",
        }}
      >
        <Typography.Text style={{ fontSize: 14, color: "whitesmoke" }}>
          {[undefined, null].includes(subPropertyOfDistrictLookup)
            ? null
            : subPropertyOfDistrictLookup[value.toString()]}
        </Typography.Text>
        <CloseCircleOutlined
          style={{ marginLeft: "5px", color: "#BECAD3" }}
          onClick={() => {
            if (isCancelledSubPropertyInInitialData(data, value)) {
              cancelSelectedSubProperty(
                isCircle
                  ? data?.circles?.find((x) => x?.id === value) ?? null
                  : data?.zones?.find((x) => x?.id === value) ?? null
              );
            } else {
              setSelectedSubProperty(
                selectedSubProperty?.filter((x) => x !== value)
              );
            }
          }}
        />
      </div>
    );
  };

  const getDistrictOptions = (districtList) =>
    districtList?.map((x) => <option value={x?.id}>{x?.name}</option>) ?? (
      <option x={0}></option>
    );

  const getSubPropertyOptions = (subPropertyList, selectedSubProperty) =>
    subPropertyList
      ?.filter((x) => !selectedSubProperty?.includes(x?.id))
      ?.map((x) => {
        if (x?.user_role_id)
          return (
            <Option
              value={x?.id + "-" + x?.name}
              label={x?.name}
              disabled={true}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {x?.name}
                <EditFilled
                  style={{ color: "black" }}
                  onClick={() =>
                    history.push(
                      isCircle
                        ? `/admin/edit-tax-inspector?id=${x?.user_id}`
                        : `/admin/edit-eto?id=${x?.user_id}`
                    )
                  }
                />
              </div>
            </Option>
          );
        else
          return (
            <Option value={x?.id + "-" + x?.name} label={x?.name}>
              {x?.name}
            </Option>
          );
      }) ?? <option x={0}></option>;

  const fetchDistrictSubProperty = (selectedDistrict) => {
    //parent function which query sagas for get Zones Of districts.
    if (selectedDistrict !== null) {
      getSubPropertyOfDistrict(selectedDistrict);
    }
  };

  const SubPropertyDistrictResponseWrapper = (obj) => {
    //mapped ids to object before sending back to parent
    const resultant = { district: null };
    if (obj?.district) {
      resultant.district =
        initialDistrictValue?.find((x) => x?.id === obj.district) ?? null;
    }
    if (obj?.subProperty) {
      const _subProperty = [];
      obj?.subProperty?.forEach((x) => {
        const candidate =
          subPropertyOfDistrict?.find((i) => i?.id === x) ?? null;
        candidate && _subProperty.push(candidate);
      });
      isCircle
        ? (resultant.circles = _subProperty)
        : (resultant.zones = _subProperty);
    }
    return resultant;
  };

  React.useEffect(() => {
    fetchDistrictSubProperty(selectedDistrict);
    setSelectedSubProperty(null);
    setDisableSubProperty(true);
  }, [selectedDistrict]);

  React.useEffect(() => {
    updateFormState(
      SubPropertyDistrictResponseWrapper({
        subProperty: selectedSubProperty,
        district: selectedDistrict,
      })
    );
  }, [selectedDistrict, selectedSubProperty]);

  React.useEffect(() => {
    if (isCircle ? data?.circles?.length > 0 : data?.zones?.length > 0) {
      setSelectedSubProperty(
        isCircle
          ? data?.circles?.map((x) => x?.id) ?? null
          : data?.zones?.map((x) => x?.id) ?? null
      );
    }
    setDisableSubProperty(false);
  }, [subPropertyOfDistrict]);

  React.useEffect(() => {
    if (![undefined, null].includes(data)) {
      setSelectedDistrict(data?.districts[0]?.id ?? null);
      fetchDistrictSubProperty(data?.districts[0]?.id ?? null);
    }
  }, [data]);

  return (
    <React.Fragment>
      <Row>
        <Col span={12} className="column-left">
          <div
            onFocus={() => {
              setStatusSelectActive(true);
            }}
            onBlur={() => {
              setStatusSelectActive(false);
            }}
            style={{ marginTop: "25px", height: "40px" }}
          >
            <InputLabel
              value={selectedDistrict}
              labelText="District"
              active={statusSelectActive}
            >
              <Select
                disabled={
                  (isCircle
                    ? data?.circles?.length > 0
                    : data?.zones?.length > 0) || data?.status === false
                }
                value={selectedDistrict}
                onChange={setSelectedDistrict}
                size="large"
              >
                {getDistrictOptions(initialDistrictValue)}
              </Select>
            </InputLabel>
          </div>
        </Col>
        <Col span={12} className="column-right">
          <div
            onFocus={() => {
              setStatusSelectActive2(true);
            }}
            onBlur={() => {
              setStatusSelectActive2(false);
            }}
            style={{ marginTop: "25px", height: "40px" }}
          >
            <InputLabel
              value={selectedSubProperty}
              labelText={isCircle ? "Circles" : "Zones"}
              active={statusSelectActive2}
            >
              <Select
                disabled={
                  data?.status === false ||
                  disableSubProperty ||
                  [undefined, null].includes(selectedDistrict)
                }
                value={selectedSubProperty?.filter((x) => x)}
                mode="multiple"
                onChange={handleSelectChange}
                size="large"
                tagRender={tagRender}
              >
                {getSubPropertyOptions(
                  subPropertyOfDistrict,
                  selectedSubProperty
                )}
              </Select>
            </InputLabel>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ marginTop: "20px", marginBottom: "-20px" }}>
          <Text type="danger">
            {`Note: If district is selected, ${
              isCircle ? "circle" : "zone"
            } must be assigned with it
            otherwise district won't be added`}
          </Text>
        </Col>
      </Row>
    </React.Fragment>
  );
}
